import {Injectable} from "@angular/core";
import {AbstractService} from "./abstract.service";
import {CorrespondenceRepo} from "../repositories/api/correspondence.repo";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {LetterPriceDto} from "../repositories/dto/letter-price.dto";
import {VoidDto} from "../repositories/dto/void.dto";
import {SubInvoiceDto} from "../repositories/dto/sub-invoice.dto";
import {EmailSendDto} from "../repositories/dto/email-send.dto";
import {MediaFileType} from "../libs/enum/media-file-type.enum";
import {SendLetterDto} from "../repositories/dto/send-letter.dto";
import {BounceDto} from "../repositories/dto/bounce.dto";

@Injectable({providedIn: 'root'})
export class CorrespondenceService extends AbstractService {

  private readonly correspondenceRepo: CorrespondenceRepo = this.repoProvider.getRepo(CorrespondenceRepo);

  public getInvoicePrice(invoiceId: string, settings: LetterPriceDto): Observable<LetterPriceDto> {
    return this.correspondenceRepo.getInvoicePrice(this.getOrg(), invoiceId, settings)
      .pipe(map((w) => w.getFirstData()));
  }

  public getSubInvoicePrice(subInvoice: SubInvoiceDto, settings: LetterPriceDto): Observable<LetterPriceDto> {
    if (subInvoice.isDeliveryNote()) {
      return this.correspondenceRepo.getDeliveryNotePrice(this.getOrg(), subInvoice.id, settings)
        .pipe(map((w) => w.getFirstData()));
    } else if (subInvoice.isProformaInvoice()) {
      return this.correspondenceRepo.getProformaInvoicePrice(this.getOrg(), subInvoice.id, settings)
        .pipe(map((w) => w.getFirstData()));
    }
    throw new Error("Sub-Invoice type not implemented");
  }

  public getLetterPrice(contactId: string, addressId: string, type: MediaFileType, settings: LetterPriceDto): Observable<LetterPriceDto> {
    return this.correspondenceRepo.getLetterPrice(this.getOrg(), contactId, addressId, type, settings)
      .pipe(map((w) => w.getFirstData()));
  }

  public sendInvoiceLetter(invoiceId: string, settings: LetterPriceDto): Observable<VoidDto> {
    return this.correspondenceRepo.sendInvoiceLetter(this.getOrg(), invoiceId, settings)
      .pipe(map((w) => w.getFirstData()));
  }

  public sendSubInvoiceLetter(subInvoice: SubInvoiceDto, settings: LetterPriceDto): Observable<VoidDto> {
    if (subInvoice.isDeliveryNote()) {
      return this.correspondenceRepo.sendDeliveryNoteLetter(this.getOrg(), subInvoice.id, settings)
        .pipe(map((w) => w.getFirstData()));
    } else if (subInvoice.isProformaInvoice()) {
      return this.correspondenceRepo.sendProformaInvoiceLetter(this.getOrg(), subInvoice.id, settings)
        .pipe(map((w) => w.getFirstData()));
    }
    throw new Error("Sub-Invoice type not implemented");
  }

  public sendLetter(dto: SendLetterDto): Observable<VoidDto> {
    return this.correspondenceRepo.sendLetter(this.getOrg(), dto)
      .pipe(map((w) => w.getFirstData()));
  }

  public sendEmail(dto: EmailSendDto): Observable<VoidDto> {
    return this.correspondenceRepo.sendEmail(this.getOrg(), dto)
      .pipe(map((w) => w.getFirstData()));
  }

  public getBounces(): Observable<BounceDto[]> {
    return this.correspondenceRepo.getBounces(this.getOrg())
      .pipe(map((w) => w.getDatas()));
  }
}
